/**
 * Levels column label: role name, with invoice type in parentheses when set.
 */
export const formatRoleLevelDisplay = (roleName, invoiceType) => {
  if (!roleName) {
    return 'N/A';
  }
  if (!invoiceType) {
    return roleName;
  }
  return `${roleName} (${invoiceType})`;
};

const toRoleIdKey = (id) => (id == null || id === '' ? null : String(id));

export const buildRoleByIdMap = (roles) => {
  const map = new Map();
  if (!Array.isArray(roles)) {
    return map;
  }
  roles.forEach((role) => {
    const key = toRoleIdKey(role?.id);
    if (key) {
      map.set(key, role);
    }
  });
  return map;
};

export const formatRoleLevelFromRoleId = (roleName, roleId, roleById) => {
  const role = roleId != null ? roleById.get(toRoleIdKey(roleId)) : null;
  const name = roleName || role?.name;
  return formatRoleLevelDisplay(name, role?.invoice_type);
};
